/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 报警日志类型
 */
let EnumAlarmLogType = {
	Login: 						new EnumItem('告警 ', 1),
    Operation: 						new EnumItem('故障', 2),
	...enumMixn
}
export default EnumAlarmLogType
